var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenAvatar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#67CE67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.294 15.2911C25.294 18.2281 22.9391 20.5831 20 20.5831C17.0619 20.5831 14.706 18.2281 14.706 15.2911C14.706 12.354 17.0619 10 20 10C22.9391 10 25.294 12.354 25.294 15.2911ZM20 30C15.6624 30 12 29.295 12 26.575C12 23.8539 15.6854 23.1739 20 23.1739C24.3386 23.1739 28 23.8789 28 26.599C28 29.32 24.3146 30 20 30Z",
    fill: "#67CE67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenAvatar2);
export default __webpack_public_path__ + "static/media/green-avatar-2.a0c2f239bfa1ae1237d10b13554e0533.svg";
export { ForwardRef as ReactComponent };